import { IResponseBaseDto } from "@sprytki-frontend-apps/common";
import { apiClient } from "./apiClient";

const ORDER_ITEMS = 'orderitems';

export const OrderItemsServiceAPI = {
  Release: async (id: string): Promise<IResponseBaseDto> => {
    const response = await apiClient.post(`${ORDER_ITEMS}/${id}/release`);
    return response.data;
  },
};
